import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResponsiveModule } from '@viablelogic/ngx-responsive';
import { DaButtonDirective, DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';

import { SingleStageComponent } from './single-stage.component';

@NgModule({
    declarations: [SingleStageComponent],
    imports: [CommonModule, ResponsiveModule, DaProgressiveImageModule, DaButtonModule, DaLinkModule],
    providers: [DaButtonDirective],
    exports: [SingleStageComponent]
})
export class SingleStageModule {
}
